// extracted by mini-css-extract-plugin
module.exports = {"historyItem":"HistoryItem_historyItem__2PYTd","itemHeader":"HistoryItem_itemHeader__2XYSP","attachments":"HistoryItem_attachments__3i9nx","note":"HistoryItem_note__SJlhF"};